export const generatorPathItem = {
  path: "/admin/generator",
  label: "Report Generator",
};
